module.exports = __webpack_public_path__ + "img/godaddy.9b3e6e3e.png";